import '@cta/frontend';

import '@campact/camper/icons/CmprIconSolidLock';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

AppBoot.start(App);
